import { Modal } from 'react-bootstrap';
import React from 'react';
import { useSelector } from 'react-redux';
import { useKeysStore } from '../../../../store/useKeysStore';

function Loading(props) {
    let show = useSelector((state) => {
        return state.core.showLoading;
    });
    const { loading } = useKeysStore();

    return (
        <>
            <Modal show={show || loading}>
                <Modal.Body>Por favor aguarde...</Modal.Body>
            </Modal>
        </>
    );
}

export default Loading;
